import { useToggle } from '../../utils/hooks/useToggle';
import { Tooltip } from 'reactstrap'

export default function TooltipElement(props) {
    const [tooltipOpen, setTooltipOpen, toggleTooltipOpen] = useToggle(false);

  return (
    <>
        <Tooltip 
            isOpen={tooltipOpen}
            target={props.target}
            toggle={toggleTooltipOpen}
        >
            {props.children}
        </Tooltip>
    </>
  )
}
